<template>
  <div class="container is-fluid" id="container-main">
    <div class="row" id="main-row">
      <div id="vapp">
        <div class="header">
          <h1>Customer: {{ customerId }}</h1>
        </div>
        <div v-if="loaded" class="columns" style="margin-top: 30px">
          <div class="column" v-for="step in getWizardSteps(getWizardMode())" :key="step">
            <div>
              <div class="container2">
                <div class="circle" :class="hasStepCompleted(step) ? 'circle' : 'circle-closed'"></div>
              </div>
              <div class="step_title">
                {{ step }}
              </div>
            </div>
            <div class="timeline">
              <div class="timeline-item" v-for="event in getStepEvents(step)" :key="event.name">
                <div class="timeline-marker"></div>
                <div class="timeline-content">
                  <div class="box" :class="event.customer_event ? 'box-green' : 'box-red'">
                    <p class="heading">{{ event.customer_event ? new Date(event.timestamp).toLocaleString() : "Not completed" }}</p>
                    <p>{{ event.event_formatted_name == "" ? event.event_name : event.event_formatted_name }}</p>
                  </div>
                </div>
              </div>
              <template v-if="hasStepCompleted(step)">
                <div class="timeline-item">
                  <div class="timeline-marker"></div>
                  <div class="timeline-content">
                    <div class="box box-green">
                      <p style="font-weight: 700">Step Completed</p>
                      <div style="text-align: center">
                        <b-icon icon="check-circle-outline" size="is-large"> </b-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--<vue-mermaid :nodes="data" type="graph LR" :config="config"></vue-mermaid>-->
    <b-loading :is-full-page="true" v-model="bigLoading" :can-cancel="true"></b-loading>
  </div>
</template>

<script>
const axios = require("axios");

export default {
  data: function () {
    return {
      customerId: -1,
      loaded: false,
      selected: {},
      isLoading: true,
      bigLoading: false,
      apiUrl: "https://api.jeak.co.uk",
      eventTypes: [],
      config: {
        theme: "neutral",
      },
      activeStep: 0,
      hasNavigation: false,
      data: [],
      wizardModes: [
        {
          name: "fixedlocation",
          steps: ["Product", "Terms", "Company", "Fixed Locations", "Confirmation", "Next Steps"],
        },
        {
          name: "full",
          steps: ["Product", "Terms", "Company", "Voice+ Options", "Fixed Locations", "Keywords", "Confirmation", "Next Steps"],
        },
      ],
      stepDefinitions: [
        {
          step_name: "Product",
          events: ["setup_begun", "mode_changed_fullvoice+", "mode_changed_fixedlocation"],
        },
        {
          step_name: "Terms",
          events: ["page_started_terms", "contract_signed", "contract_created"],
        },
        {
          step_name: "Company",
          events: ["page_started_company"],
        },
        {
          step_name: "Voice+ Options",
          events: ["page_started_voice_options"],
        },
        {
          step_name: "Fixed Locations",
          events: ["page_started_fixed_locations", "added_fixed_location"],
        },
        {
          step_name: "Keywords",
          events: ["page_started_keywords", "added_keyword"],
        },
        {
          step_name: "Confirmation",
          events: ["page_started_confirmation"],
        },
        {
          step_name: "Next Steps",
          events: ["test_numbers_assigned", "finished_testing", "placed_voice_plus_live"],
        },
      ],
    };
  },
  methods: {
    GetEventTypes: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const res = await axios.get(this.apiUrl + "/events", config);
      this.eventTypes = res.data;
    },
    GetItems: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      axios
        .get(this.apiUrl + "/customerevents/" + this.customerId, config)
        .then((response) => {
          this.data = [];
          this.data = response.data;
          this.loaded = true;
        })
        .catch((error) => {});
    },
    getStepEvents: function (stepName) {
      let stepFound = false;
      for (const step of this.stepDefinitions) {
        if (step.step_name == stepName) {
          stepFound = step;
          break;
        }
      }
      if (stepFound == false) throw new Error("Step not found: " + stepName);

      const events = [];

      for (const event of stepFound.events) {
        let eventsFound = 0;
        for (const customerEvent of this.data) {
          if (customerEvent.event_name == event) {
            customerEvent.customer_event = true;
            events.push(customerEvent);
            eventsFound++;
          }
        }
        if (eventsFound == 0) {
          const eventDef = this.getEventDefinition(event);
          eventDef.customer_event = false;
          events.push(eventDef);
        }
      }

      events.sort(function (a, b) {
        const keyA = new Date(a.timestamp);
        const keyB = new Date(b.timestamp);
        // Compare the 2 dates
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
      });

      return events;
    },
    getEventDefinition: function (eventName) {
      for (const event of this.eventTypes) {
        if (event.event_name == eventName) {
          return event;
        }
      }

      return {
        event_id: -1,
        event_name: eventName,
        event_formatted_name: "",
        event_description: "N/A",
      };
    },
    hasStepCompleted: function (stepName) {
      const events = this.getStepEvents(stepName);

      let eventMissing = false;

      const eventNamesMissing = [];
      const eventNamesFound = [];

      //--- Check if any events are missing
      //--- Also compile event missing and found names into arrays
      for (const event of events) {
        if (!event.customer_event) {
          eventMissing = true;
          eventNamesMissing.push(event.event_name);
        } else {
          eventNamesFound.push(event.event_name);
        }
      }

      if (eventMissing) {
        if (stepName == "Product") {
          //--- Step is "Mode" this is important for the optional fixedlocation toggle
          //--- Check if its only the voiceplus mode events that are missing
          let foundOthers = false;
          for (const eventMissing of eventNamesMissing) {
            if (!(eventMissing == "mode_changed_fullvoiceplus" || eventMissing == "mode_changed_fixedlocation")) {
              foundOthers = true;
            }
          }

          if (foundOthers) {
            //--- Other events are missing so this step has not been completed yet
            return false;
          } else {
            //--- Only missing the voiceplus mode events
            //--- Do we have one of the toggle events as part of the found events?
            if (eventNamesFound.includes("mode_changed_fullvoiceplus") || eventNamesFound.includes("mode_changed_fixedlocation")) {
              //--- Voiceplus toggle events found so we have finished the stage
              return true;
            } else {
              //--- Voiceplus toggle events not found so we have not finished the stage yet
              return false;
            }
          }
        } else {
          //--- The step is not "Mode" so no exceptions here - Not completed yet!
          return false;
        }
      } else {
        //--- No events missing so we have completed
        return true;
      }
    },
    getWizardMode: function () {
      if (this.data == []) return;

      const events = this.getStepEvents("Product");

      let type = "";

      for (let i = events.length - 1; i > 0; i--) {
        const event = events[i];
        if (event.event_name == "mode_changed_fullvoice+") {
          type = "full";
          break;
        }

        if (event.event_name == "mode_changed_fixedlocation") {
          type = "fixedlocation";
          break;
        }
      }

      return type;
    },
    getWizardSteps: function (wizardMode) {
      for (const mode of this.wizardModes) {
        if (mode.name == wizardMode) {
          return mode.steps;
        }
      }

      return [];
    },
  },
  async mounted() {
    this.customerId = this.$route.params.customerId;
    await this.GetEventTypes();
    this.GetItems();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.flowBox {
  display: flex;
}

.container2 {
  width: calc(100% + 1.5rem);
  height: 2px;
  background-color: #dbdbdb;
  position: relative;
}

.box {
  width: 180px;
  word-break: break-word;
}

.box-red {
  background-color: #f79797f2;
}

.box-green {
  background-color: #68f185;
}

.circle {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 40px;
  background-color: white;
  border: solid 5px #47d061;
  border-radius: 50%;
  position: absolute;
  top: -15px;
  left: 12px;
  z-index: 9999;
}
.circle-closed {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 40px;
  background-color: #b5b5b5;
  border: solid 3px #8c8a8a;
  border-radius: 50%;
  position: absolute;
  top: -15px;
  left: 12px;
  z-index: 9999;
}
.cirlce-not-completed {
  border: solid 5px #ffd743;
}
.step_title {
  text-align: left;
  margin-top: 25px;
  margin-left: 40px;
  font-weight: 800;
  font-size: 25px;
}

.timeline .timeline-item::before {
  top: -50px;
}

.container.is-fluid {
  max-width: none !important;
  padding-left: 0px;
  padding-right: 0px;
  width: 100%;
}
</style>
